import type {
  PriceWithProduct,
  SubscriptionWithPriceAndProduct,
} from "@convex/billing";
import { createContext } from "react";
import type { Profile } from "@/types/types";

export const ProfileContext = createContext<
  (Profile & { isAdmin?: boolean; isCustomer?: boolean }) | null
>(null);

export const SubscriptionContext =
  createContext<SubscriptionWithPriceAndProduct | null>(null);

export const CreditsContext = createContext<{
  extraCreditPrices: PriceWithProduct[];
} | null>(null);

/**
 * Context for subscription prices with their discount rates.
 * Used to calculate upgrade hints and max discount for non-subscribers.
 */
export const SubscriptionPricesContext = createContext<
  PriceWithProduct[] | null
>(null);
